var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable i18next/no-literal-string -- Dev tools don't use translations */
import { Button } from '@lucidlink/uicore';
import { useLucidDevTools } from '#context';
import { getDevEnvValue } from '#services';
export const OpenLucidDevTools = () => {
    _react_refresh_temp_2();
    const { toggleLucidDevToolsWidget } = useLucidDevTools();
    const shouldRenderDevTools = getDevEnvValue({
        defaultValue: false,
        devEnvValue: true,
    });
    if (shouldRenderDevTools) {
        return (_jsx(Button, { "data-testid": "debug", onClick: toggleLucidDevToolsWidget, children: "Debug" }));
    }
    return null;
};
_react_refresh_temp_1 = OpenLucidDevTools;
$RefreshReg$(_react_refresh_temp_1, "OpenLucidDevTools");
_react_refresh_temp_2(OpenLucidDevTools, "yR9e7xrlJ1KWIKuZ89cI5rbiZ04=", false, () => [useLucidDevTools]);
